import { createContext, useContext, useState, useCallback } from 'react'

const ToastContext = createContext()

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([])

  const addToast = useCallback((message, type = 'info', duration = 5000) => {
    const id = Date.now()
    const toast = { id, message, type }
    
    setToasts(prev => [...prev, toast])
    
    setTimeout(() => {
      setToasts(prev => prev.filter(t => t.id !== id))
    }, duration)
  }, [])

  const removeToast = useCallback((id) => {
    setToasts(prev => prev.filter(t => t.id !== id))
  }, [])

  return (
    <ToastContext.Provider value={{ toasts, addToast, removeToast }}>
      {children}
      <ToastStack toasts={toasts} removeToast={removeToast} />
    </ToastContext.Provider>
  )
}

function ToastStack({ toasts, removeToast }) {
  const getAlertClass = (type) => {
    switch (type) {
      case 'error':
        return 'alert-error'
      case 'success':
        return 'alert-success'
      case 'warning':
        return 'alert-warning'
      default:
        return 'alert-info'
    }
  }

  return (
    <div className="toast-stack">
      {toasts.map(toast => (
        <div
          key={toast.id}
          role="alert"
          className={`alert ${getAlertClass(toast.type)} shadow-lg`}
        >
          <span>{toast.message}</span>
          <button
            className="btn btn-sm btn-ghost"
            onClick={() => removeToast(toast.id)}
          >
            ✕
          </button>
        </div>
      ))}
    </div>
  )
}

export const useToast = () => {
  const context = useContext(ToastContext)
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider')
  }
  return context
}